module.exports = __webpack_public_path__ + "static/media/outlinedShield.f64295ed.svg";